const routing = {
  legalEntity: '/legalentity',
  acesso: '/acessotopup',
  cnab: '/cnab',
  acessoProcess: '/cardrelease',
  user: '/user',
  batch: '/batch',
  campaigns: '/campaign',
  contract: '/contract',
  commercialagent: '/commercialagent',
  order: '/order',
  servicecodes: '/servicecodes',
  dcp: '/dcp',
  gm: '/PaaSintegration',
  orderItems: '/orderItems',
  statement: '/bankStatements',
  banks: '/banks',
  company: '/company',
  product: '/product',
  notification: '/notification',
  individual: '/individual',
  logserpro: 'logserpro',
  invoice: '/invoice',
  service: '/service',
  joycode: '/joycode',
  card: '/card',
  rps: '/rps',
  paymentSlip: '/paymentSlip',
  bankly: '/bankStatus',
  tutorials: '/tutorials',
  statementQuery : '/statement-query',
  permissions: '/permissionsGroup',
  costCenters: '/costCenter',
  suppliers: '/supplier',
  billsToPay: '/billsToPay',
  receivables: '/receivables',
  fixedVariableExpenses: '/fixed-variable-expenses',
  cashFlow: '/cashFlow',
  dreReport: '/dre-report',
  category: '/category'
};

export default routing;
